import { render, staticRenderFns } from "./uptrend.vue?vue&type=template&id=365d1085&"
import script from "./uptrend.vue?vue&type=script&lang=js&"
export * from "./uptrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports